import { render, staticRenderFns } from "./InvoicesList.vue?vue&type=template&id=1395ea10&scoped=true"
import script from "./InvoicesList.vue?vue&type=script&lang=js"
export * from "./InvoicesList.vue?vue&type=script&lang=js"
import style0 from "./InvoicesList.vue?vue&type=style&index=0&id=1395ea10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1395ea10",
  null
  
)

export default component.exports